module.exports = __webpack_public_path__ + "img/icon-customer-service.1670758a.png";